import React from "react";
import { pdf } from "@react-pdf/renderer";

import { IDemoPersistedRoiRequest, mapDemoStoredRequestToDetails } from "../../roi-request-create/model/roi-request-create.storage";
import { buildRoiRequestPdfModel } from "./roi-request-pdf";
import { RoiRequestPdfDocument } from "../ui/roi-request-pdf-document";
import { getRoiRequestViewSections } from "../../roi-request-view/model/roi-request-view";

export const downloadRoiRequestPdf = async ({
  patientId,
  request,
}: {
  patientId: string;
  request: IDemoPersistedRoiRequest;
}) => {
  const requestDetails = mapDemoStoredRequestToDetails(request);
  const viewSections = getRoiRequestViewSections({
    patientId,
    request,
  });
  const pdfModel = buildRoiRequestPdfModel({
    requestDetails,
    viewSections,
  });
  const blob = await pdf(<RoiRequestPdfDocument data={pdfModel} />).toBlob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = window.document.createElement("a");

  link.href = downloadUrl;
  link.download = pdfModel.fileName;
  window.document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
};
